module.exports = __webpack_public_path__ + "img/BSLC_LOGO_W.693cbf8d.png";